module.exports = __webpack_public_path__ + "img/鞋楦转换ico.f8137f48.png";